export namespace AdminFormNames {
  export const AccountSettings = 'AccountSettings';
  export const AddClientAdmin = 'AddClientAdmin';
  export const AddDemographic = 'AddDemographic';
  export const AddDepartment = 'AddDepartment';
  export const AddSSOProviderDomain = 'AddSSOProviderDomain';
  export const AddUser = 'AddUser';
  export const AutomatedEmail = 'AutomatedEmail';
  export const BenchmarkDataType = 'BenchmarkDataType';
  export const ChangeDepartmentParent = 'ChangeDepartmentParent';
  export const ChangeDepartmentPosition = 'ChangeDepartmentPosition';
  export const ConnectedDepartmentsForm = 'ConnectedDepartmentsForm';
  export const ContactList = 'ContactList';
  export const ContactListType = 'ContactListType';
  export const CopyOnDemandPoll = 'CopyOnDemandPoll';
  export const CreateClient = 'CreateClient';
  export const CreateProject = 'CreateProject';
  export const CreateProjectTemplate = 'CreateProjectTemplate';
  export const CreateProjectType = 'CreateProjectType';
  export const CreateQuestion = 'CreateQuestion';
  export const CreateQuestionSettings = 'CreateQuestionSettings';
  export const CreateQuestionTranslation = 'CreateQuestionTranslation';
  export const CustomCategory = 'CustomCategory';
  export const CustomKioskCodesSettings = 'CustomKioskCodesSettings';
  export const DemandEmailReminder = 'OnDemandPoll';
  export const DistributeLifecycleToChosenEmployees = 'DistributeLifecycleToChosenEmployees';
  export const ProjectEmailTemplate = 'ProjectEmailTemplate';
  export const EmailTest = 'EmailTest';
  export const Employee = 'Employee';
  export const EmployeeUploadType = 'EmployeeUploadType';
  export const EnableAISummaries = 'EnableAISummaries';
  export const EnableHeadlines = 'EnableHeadlines';
  export const EnableAct = 'EnableAct';
  export const EnableCodelessApi = 'EnableCodelessApi';
  export const EnableDemographicsApi = 'EnableDemographicsApi';
  export const EnableDepartmentsApi = 'EnableDepartmentsApi';
  export const EnableLifecycleDistributionListApi = 'EnableLifecycleDistributionListApi';

  export const EnableOpenAvailableSurveysLinkApi = 'EnableOpenAvailableSurveysLinkApi';
  export const EnableRespondentsApi = 'EnableRespondentsApi';
  export const EnableTextAnalytics = 'EnableTextAnalytics';
  export const ExportData = 'ExportData';
  export const ImportSurvey = 'ImportSurvey';
  export const LiveStopDate = 'LiveStopDate';
  export const ManageSurvey = 'ManageSurvey';
  export const MoveQuestion = 'MoveQuestion';
  export const MultiFactorAuthenticationSettings = 'MultiFactorAuthentication';
  export const MultiLanguage = 'MultiLanguage';
  export const MultiLanguageDashboardLanguages = 'MultiLanguageDashboardLanguages';
  export const MultiLanguageEnabledLanguage = 'MultiLanguageEnabledLanguage';
  export const Notifications = 'Notifications';
  export const OnDemandPoll = 'OnDemandPoll';
  export const PageItemLogic = 'PageItemLogic';
  export const PreviewSurvey = 'PreviewSurvey';
  export const PreviousSurvey = 'PreviousSurvey';
  export const PreviousTemplate = 'PreviousTemplate';
  export const ProjectSettings = 'ProjectSettings';
  export const PulseProjectDate = 'PulseProjectDate';
  export const PulseSurveyFrequency = 'PulseSurveyFrequency';
  export const PulseSurveySettings = 'PulseSurveySettings';
  export const PulseSurveyStartDate = 'PulseSurveyStartDate';
  export const QuestionKind = 'QuestionKind';
  export const QuestionLibrary = 'QuestionLibrary';
  export const QuestionTrends = 'QuestionTrends';
  export const PulseEmailTemplate = 'PulseEmailTemplate';
  export const PulseEmailTemplateTranslation = 'PulseEmailTemplateTranslation';
  export const ScheduleForm = 'ScheduleForm';
  export const EmailScheduleForm = 'EmailScheduleForm';
  export const SearchContact = 'SearchContact';
  export const SelectConnectedPulses = 'SelectConnectedPulses';
  export const SetupCompanyDetails = 'SetupCompanyDetails';
  export const SurveySettings = 'SurveySettings';
  export const TextOrMediaEditor = 'TextOrMediaEditor';
  export const TextOrMediaEditorTranslation = 'TextOrMediaEditorTranslation';
  export const TrendDataType = 'TrendDataType';
  export const UploadBenchmarkData = 'UploadBenchmarkData';
  export const UploadDepartments = 'UploadDepartments';
  export const UploadEmployees = 'UploadEmployees';
  export const UploadLifecycleAudience = 'UploadLifecycleAudience';
  export const UploadTrendData = 'UploadTrendData';
  export const UploadUsers = 'UploadUsers';
}

export type AdminFormName = keyof typeof AdminFormNames;
